(function () {
  'use strict';

  if (window.__queCartLoaded) return;
  window.__queCartLoaded = true;

  var SAVED_KEY = 'que:saved-for-later';
  var root = null;          // the cart instance the current handler belongs to
  var roots = [];           // every live instance: the /cart page and/or the drawer
  var state = { tab: 'look', expanded: false, recHtml: null, recKey: null, offersHtml: null, offersKey: null, busy: false };

  /* ---------- tiny helpers ------------------------------------------------ */
  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  function readSaved() {
    try {
      var raw = window.localStorage.getItem(SAVED_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) { return []; }
  }
  function writeSaved(list) {
    try { window.localStorage.setItem(SAVED_KEY, JSON.stringify(list.slice(0, 50))); } catch (e) {}
  }

  function toast(msg, isError) {
    // Only show toasts for actual warnings/errors -- routine confirmations
    // (removed, saved, already in cart, etc.) are silent since the cart UI
    // itself already reflects the change.
    if (!isError) return;
    var wrap = document.querySelector('.qc-toasts');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'qc-toasts';
      wrap.setAttribute('role', 'status');
      wrap.setAttribute('aria-live', 'polite');
      document.body.appendChild(wrap);
    }
    var el = document.createElement('div');
    el.className = 'qc-toast' + (isError ? ' qc-toast--error' : '');
    el.textContent = msg;
    wrap.appendChild(el);
    window.setTimeout(function () {
      el.style.opacity = '0';
      el.style.transition = 'opacity .25s ease';
      window.setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 260);
    }, 2600);
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error((data && (data.description || data.message)) || 'Cart update failed');
        return data;
      });
    });
  }

  /* ---------- re-render the whole section --------------------------------- */
  function sectionId() { return root.getAttribute('data-section-id') || 'main-cart'; }

  function applySection(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.querySelector('[data-que-cart]');
    if (!next) { window.location.reload(); return; }

    roots = roots.filter(function (r) { return document.contains(r); });
    var previous = root;

    roots.forEach(function (instance) {
      root = instance;

      // keep scroll position of the recommendation rail
      var oldRail = $('[data-qc-rail]');
      var railLeft = oldRail ? oldRail.scrollLeft : 0;

      Array.prototype.forEach.call(next.attributes, function (attr) {
        // Every attribute syncs across instances EXCEPT the section id --
        // the /cart page's own section and the drawer's pre-rendered section
        // are two distinct Shopify section instances with two different real
        // ids, and each must keep its own so future fetches for either one
        // target the right instance.
        if (attr.name.indexOf('data-') === 0 && attr.name !== 'data-section-id') {
          instance.setAttribute(attr.name, attr.value);
        }
      });
      instance.innerHTML = next.innerHTML;

      restoreTab();
      restoreBreakdown();
      renderSaved();
      mountRecommendations();
      mountOffers();
      syncHeaderOffset();

      var rail = $('[data-qc-rail]');
      if (rail && railLeft) rail.scrollLeft = railLeft;
    });

    root = previous && document.contains(previous) ? previous : roots[0] || null;
    updateHeaderBubble();
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  function refresh(data) {
    if (data && data.sections && data.sections[sectionId()]) {
      applySection(data.sections[sectionId()]);
      return Promise.resolve();
    }
    var url = (root.getAttribute('data-cart-url') || '/cart') + '?section_id=' + encodeURIComponent(sectionId());
    return fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(applySection);
  }

  function updateHeaderBubble() {
    var count = parseInt(root.getAttribute('data-cart-count'), 10) || 0;
    var bubbles = document.querySelectorAll('.cart-link__bubble');
    if (bubbles.length) {
      Array.prototype.forEach.call(bubbles, function (el) {
        var num = el.querySelector('.cart-link__bubble-num');
        if (num) { num.textContent = count; } else { el.textContent = count; }
        el.classList.toggle('cart-link__bubble--visible', count > 0);
        el.style.display = count > 0 ? '' : 'none';
      });
    } else if (count > 0) {
      // theme only prints the bubble when the cart had items on page load
      var host = document.querySelector('.cart-link__wrapper, .cart-link, .site-header__cart');
      if (host) {
        var span = document.createElement('span');
        span.className = 'cart-link__bubble cart-link__bubble--visible';
        span.textContent = count;
        host.appendChild(span);
      }
    }
  }

  function setBusy(el, on) {
    if (!el) return;
    el.classList.toggle('is-busy', !!on);
  }

  /* ---------- cart operations --------------------------------------------- */
  function changeLine(key, quantity, itemEl) {
    if (state.busy) return Promise.resolve();
    state.busy = true;
    setBusy(itemEl, true);
    return postJSON(root.getAttribute('data-change-url') || '/cart/change.js', {
      id: key, quantity: quantity, sections: sectionId()
    })
      .then(refresh)
      .catch(function (err) { toast(err.message, true); })
      .then(function () { state.busy = false; setBusy(itemEl, false); });
  }

  function addVariant(variantId, quantity, opts) {
    opts = opts || {};
    return postJSON(root.getAttribute('data-add-url') || '/cart/add.js', {
      items: [{ id: Number(variantId), quantity: quantity || 1 }],
      sections: sectionId()
    })
      .then(function (data) {
        if (!opts.silent) toast(opts.message || 'Added to your cart');
        return refresh(data);
      })
      .catch(function (err) { toast(err.message, true); throw err; });
  }

  function findKeyByVariant(variantId) {
    var el = $('[data-qc-item][data-variant="' + variantId + '"]');
    return el ? el.getAttribute('data-key') : null;
  }

  /* ---------- saved for later ---------------------------------------------- */
  function saveItem(itemEl) {
    var entry = {
      variantId: itemEl.getAttribute('data-variant'),
      key: itemEl.getAttribute('data-key'),
      title: itemEl.getAttribute('data-title'),
      url: itemEl.getAttribute('data-url'),
      image: itemEl.getAttribute('data-image'),
      price: itemEl.getAttribute('data-price'),
      qty: parseInt(itemEl.getAttribute('data-qty'), 10) || 1
    };
    var list = readSaved().filter(function (x) { return x.variantId !== entry.variantId; });
    list.unshift(entry);
    writeSaved(list);
    renderSaved();
    // Bookmarked in the "Saved For Later" tab now, so pull the line out of
    // the cart itself -- otherwise it shows (and gets charged) in both
    // places at once.
    return changeLine(entry.key, 0, itemEl).then(function () {
      toast('Saved for later');
    });
  }

  function renderSaved() {
    var list = readSaved();
    var wrap = $('[data-qc-saved-list]');
    var empty = $('[data-qc-saved-empty]');
    var badge = $('[data-qc-saved-count]');
    var block = $('[data-qc-saved-block]');
    if (badge) badge.textContent = list.length ? '(' + list.length + ')' : '';
    if (block) block.hidden = !list.length;
    if (!wrap) return;
    if (!list.length) {
      wrap.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    // Same card markup/classes as "Complete Your Look" (.qc-rec) so Saved
    // For Later matches that rail's look exactly, plus a small remove (x)
    // overlay on the thumbnail and "Move to cart" as the card's CTA.
    wrap.innerHTML = list.map(function (it) {
      var img = it.image
        ? '<img src="' + escapeAttr(it.image) + '" alt="" width="240" height="240" loading="lazy">'
        : '';
      return '' +
        '<div class="qc-rec qc-rec--saved" data-qc-saved-row data-variant="' + escapeAttr(it.variantId) + '">' +
          '<a class="qc-rec__media" href="' + escapeAttr(it.url || '#') + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
          '<button type="button" class="qc-rec__remove" data-qc-saved-remove aria-label="Remove from saved">\u2715</button>' +
          '<div class="qc-rec__body">' +
            '<a class="qc-rec__name" href="' + escapeAttr(it.url || '#') + '">' + escapeHtml(it.title || '') + '</a>' +
            '<span class="qc-rec__price">' + escapeHtml(it.price || '') + '</span>' +
            '<button type="button" class="qc-rec__add" data-qc-saved-move>Move to cart</button>' +
          '</div>' +
        '</div>';
    }).join('');
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function escapeAttr(s) { return escapeHtml(s == null ? '' : s); }

  /* ---------- recommendations ("Complete Your Look") ----------------------- */
  /*
    "Complete Your Look" (curated or automatic) and "Best Offers" used to be
    rendered inline by the Liquid section, which meant every add-to-cart /
    cart-change paid to re-render up to ~20 product cards server-side before
    the drawer could show anything. Both rails now load in the background,
    after the cart items/total are already on screen, via lightweight public
    JSON endpoints — so the drawer opens and shows your cart info fast, and
    the rails fill in a beat later without blocking that.
  */
  function pathPrefix() {
    var prefix = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (prefix.charAt(prefix.length - 1) !== '/') prefix += '/';
    return prefix;
  }

  function imgWithWidth(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function formatMoney(amount) {
    var fmt = (root && root.getAttribute('data-money-format')) || '{{amount}}';
    var n = isNaN(amount) ? 0 : amount;
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(n).toString())
      .replace(/\{\{\s*amount\s*\}\}/, n.toFixed(2));
  }

  function firstAvailableVariant(product) {
    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available) return variants[i];
    }
    return variants[0] || null;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Mirrors snippets/que-cart-product-card.liquid, built client-side from
  // /collections/{handle}/products.json so those product loops no longer
  // have to run inside the cart section's own server render.
  function buildRecCard(product) {
    var variant = firstAvailableVariant(product);
    var img = product.images && product.images[0] && (product.images[0].src || product.images[0]);
    var url = pathPrefix() + 'products/' + product.handle;
    var price = variant ? parseFloat(variant.price) : 0;
    var compareAt = variant && variant.compare_at_price ? parseFloat(variant.compare_at_price) : 0;
    var priceHtml = formatMoney(price) + (compareAt > price ? '<s>' + formatMoney(compareAt) + '</s>' : '');

    var addHtml;
    if (product.available === false || !variant) {
      addHtml = '<button type="button" class="qc-rec__add" disabled>Sold out</button>';
    } else if ((product.variants || []).length === 1) {
      addHtml = '<button type="button" class="qc-rec__add" data-qc-rec-add="' + variant.id + '">+ Add</button>';
    } else {
      addHtml = '<a class="qc-rec__add qc-rec__add--link" href="' + url + '">+ Add</a>';
    }

    return '<div class="qc-rec" data-qc-rec>' +
      '<a class="qc-rec__media" href="' + url + '" tabindex="-1" aria-hidden="true">' +
      (img ? '<img src="' + imgWithWidth(img, 240) + '" alt="' + escapeHtml(product.title) + '" width="240" height="240" loading="lazy">' : '') +
      '</a>' +
      '<div class="qc-rec__body">' +
      '<a class="qc-rec__name" href="' + url + '">' + escapeHtml(product.title) + '</a>' +
      '<span class="qc-rec__price">' + priceHtml + '</span>' +
      addHtml +
      '</div></div>';
  }

  function fetchCollectionCards(handle, limit) {
    var url = pathPrefix() + 'collections/' + handle + '/products.json?limit=' + encodeURIComponent(limit);
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data && data.products) || [];
        return products.map(buildRecCard).join('');
      });
  }

  function mountRecommendations() {
    var rail = $('[data-qc-rail]');
    if (!rail) return;

    var source = root.getAttribute('data-rec-source');
    var isCollection = source === 'collection';
    var handle = root.getAttribute('data-rec-collection');
    var limit = root.getAttribute('data-rec-limit') || 10;
    var seed = root.getAttribute('data-seed-product');

    if (!isCollection && (!seed || seed === '0')) {
      rail.innerHTML = '<p class="qc-empty-note">Add a pair to see what goes with it.</p>';
      syncRailNav();
      return;
    }

    var key = isCollection
      ? ['collection', handle, limit].join('|')
      : [seed, root.getAttribute('data-rec-intent'), limit].join('|');

    if (state.recKey === key && state.recHtml) {
      rail.innerHTML = state.recHtml;
      markInCart();
      syncRailNav();
      return;
    }

    var request = isCollection
      ? fetchCollectionCards(handle, limit)
      : fetch(
          (root.getAttribute('data-recommend-url') || '/recommendations/products') +
          '?section_id=que-cart-recommendations' +
          '&product_id=' + encodeURIComponent(seed) +
          '&limit=' + encodeURIComponent(limit) +
          '&intent=' + encodeURIComponent(root.getAttribute('data-rec-intent') || 'complementary'),
          { headers: { Accept: 'text/html' } }
        )
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var list = doc.querySelector('[data-qc-rec-list]');
            return list ? list.innerHTML.trim() : '';
          });

    request
      .then(function (cards) {
        if (!cards) {
          rail.innerHTML = '<p class="qc-empty-note">No pairings for this one yet.</p>';
        } else {
          state.recKey = key;
          state.recHtml = cards;
          rail.innerHTML = cards;
          markInCart();
        }
        syncRailNav();
      })
      .catch(function () {
        rail.innerHTML = '<p class="qc-empty-note">Couldn’t load recommendations.</p>';
        syncRailNav();
      });
  }

  function mountOffers() {
    var rail = $('[data-qc-offers-rail]');
    if (!rail || root.getAttribute('data-offers-source') !== 'collection') return;

    var handle = root.getAttribute('data-offers-collection');
    var limit = root.getAttribute('data-offers-limit') || 10;
    var key = ['collection', handle, limit].join('|');

    if (state.offersKey === key && state.offersHtml) {
      rail.innerHTML = state.offersHtml;
      markInCart();
      return;
    }

    fetchCollectionCards(handle, limit)
      .then(function (cards) {
        if (!cards) {
          rail.innerHTML = '<p class="qc-empty-note">No offers right now.</p>';
        } else {
          state.offersKey = key;
          state.offersHtml = cards;
          rail.innerHTML = cards;
          markInCart();
        }
      })
      .catch(function () {
        rail.innerHTML = '<p class="qc-empty-note">Couldn’t load offers.</p>';
      });
  }

  /*
    Once a product from an upsell rail (Complete Your Look or the Best
    Offers collection) is already in the cart, hide its card entirely
    instead of just flipping the button to "In cart" -- keeps the rail
    showing only things the person hasn't already added. Re-checked on
    every render, so a card reappears if the item is later removed.
  */
  function markInCart() {
    $$('[data-qc-rail], [data-qc-offers-rail]').forEach(function (rail) {
      var anyVisible = false;
      $$('[data-qc-rec]', rail).forEach(function (card) {
        var btn = card.querySelector('[data-qc-rec-add]');
        var v = btn && btn.getAttribute('data-qc-rec-add');
        var inCart = !!(v && findKeyByVariant(v));
        card.hidden = inCart;
        if (!inCart) anyVisible = true;
      });
      var note = rail.querySelector('[data-qc-rail-all-added]');
      var hasCards = !!rail.querySelector('[data-qc-rec]');
      if (hasCards && !anyVisible) {
        if (!note) {
          note = document.createElement('p');
          note.className = 'qc-empty-note';
          note.setAttribute('data-qc-rail-all-added', '');
          note.textContent = 'You’ve added everything here — nice!';
          rail.appendChild(note);
        }
        note.hidden = false;
      } else if (note) {
        note.hidden = true;
      }
    });
  }

  function syncRailNav() {
    var rail = $('[data-qc-rail]');
    var prev = $('[data-qc-rail-prev]');
    var next = $('[data-qc-rail-next]');
    if (!rail || !prev || !next) return;
    var overflow = rail.scrollWidth - rail.clientWidth > 4;
    prev.hidden = !overflow || rail.scrollLeft <= 2;
    next.hidden = !overflow || rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
  }

  /*
    The "Your Cart" title bar is sticky (always pinned to the top). When the
    banner/reward-tiers band is ALSO set to stick, it needs to dock right
    below the title bar rather than underneath it -- so we measure the title
    bar's real rendered height and expose it as a CSS var the band's `top`
    can use, instead of a guessed pixel value that breaks on text reflow.
  */
  function syncHeaderOffset() {
    var head = root && root.querySelector('.qc-head');
    var h = head ? Math.round(head.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--qc-head-h', h + 'px');
  }

  /* ---------- tabs / disclosure -------------------------------------------- */
  function selectTab(name) {
    state.tab = name;
    $$('[data-qc-tab]').forEach(function (btn) {
      btn.setAttribute('aria-selected', String(btn.getAttribute('data-qc-tab') === name));
    });
    $$('[data-qc-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-qc-panel') !== name;
    });
    if (name === 'look') window.requestAnimationFrame(syncRailNav);
  }
  function restoreTab() {
    if (!$('[data-qc-tab="' + state.tab + '"]')) state.tab = 'look';
    selectTab(state.tab);
  }

  function restoreBreakdown() {
    var toggle = $('[data-qc-total-toggle]');
    var panel = $('[data-qc-breakdown]');
    if (!toggle || !panel) return;
    toggle.setAttribute('aria-expanded', String(state.expanded));
    panel.hidden = !state.expanded;
  }

  /* ---------- offers sheet -------------------------------------------------- */
  var lastFocus = null;
  function openSheet() {
    var sheet = $('[data-qc-offers-sheet]');
    if (!sheet) return;
    lastFocus = document.activeElement;
    sheet.hidden = false;
    document.body.style.overflow = 'hidden';
    window.requestAnimationFrame(function () { sheet.classList.add('is-open'); });
    var close = sheet.querySelector('.qc-sheet__close');
    if (close) close.focus();
  }
  function closeSheet() {
    var sheet = $('[data-qc-offers-sheet]');
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('is-open');
    document.body.style.overflow = '';
    window.setTimeout(function () { sheet.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function eligibleCodes() {
    return (root.getAttribute('data-eligible-codes') || '')
      .split(',').map(function (c) { return c.trim(); }).filter(Boolean);
  }

  function showOfferError(msg) {
    $$('[data-qc-offer-error]').forEach(function (el) {
      el.textContent = msg || '';
      el.hidden = !msg;
    });
  }

  /*
    Applying an offer does two things in a single /cart/update.js call:
      1. discount — asks Shopify to apply it for real. Unknown codes are
         silently ignored by Shopify (200, discount just doesn't land), which
         is fine and tolerated.
      2. attributes: { _offer_code } — records the shopper's choice for any
         code this cart qualifies for, so the applied state renders
         immediately and Shopify picks the code up at checkout.
    Both are sent together with sections in one request (previously two
    sequential requests) so applying a code only costs one round trip.
    Feedback is inline; nothing pops up.

    The section swap can be slow on a heavy cart, so applying a code isn't
    left to hang indefinitely on "Applying…": it gets a short floor (so the
    state always reads as real loading, not a flash) and a hard ceiling of
    ~2.5s. If the real confirmation hasn't landed by the ceiling AND the
    code is one this cart is already known to qualify for, onSlow (passed
    in by the caller) fires so the button can flip to "Applied" early while
    the real request keeps running in the background -- it still calls
    refresh() and reconciles the actual totals/state whenever it lands, or
    surfaces showOfferError() if it turns out to have failed.
  */
  var MIN_APPLY_MS = 500;
  var MAX_APPLY_MS = 2500;

  function setDiscount(code, onSlow) {
    if (state.busy) return Promise.resolve();
    state.busy = true;
    var url = root.getAttribute('data-update-url') || '/cart/update.js';
    var up = (code || '').trim().toUpperCase();
    var known = !up || eligibleCodes().indexOf(up) !== -1;

    var request = postJSON(url, {
      discount: up,
      attributes: { _offer_code: known ? up : '' },
      sections: sectionId()
    });

    if (up && known && typeof onSlow === 'function') {
      var settled = false;
      request.then(function () { settled = true; }, function () { settled = true; });
      setTimeout(function () { if (!settled) onSlow(); }, MAX_APPLY_MS);
    }

    var minWait = up
      ? new Promise(function (resolve) { setTimeout(resolve, MIN_APPLY_MS); })
      : Promise.resolve();

    return Promise.all([request, minWait])
      .then(function (results) { return refresh(results[0]); })
      .then(function () {
        var live = (root.getAttribute('data-applied-code') || '').toUpperCase();
        if (up && live !== up) {
          showOfferError('That code isn\u2019t valid for this cart.');
        } else {
          showOfferError('');
        }
      })
      .catch(function (err) { showOfferError(err.message || 'Could not update the offer.'); })
      .then(function () { state.busy = false; });
  }

  function switchOfferTab(btn) {
    var wrap = btn.closest('.qc-offers');
    if (!wrap) return;
    var name = btn.getAttribute('data-qc-offer-tab');
    wrap.querySelectorAll('[data-qc-offer-tab]').forEach(function (b) {
      var on = b.getAttribute('data-qc-offer-tab') === name;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-selected', String(on));
    });
    wrap.querySelectorAll('[data-qc-offer-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-qc-offer-panel') !== name;
    });
  }

  function submitCoupon(box, onSlow) {
    if (!box) return Promise.resolve();
    var input = box.querySelector('[data-qc-coupon-input]');
    var code = (input && input.value || '').trim();
    if (!code) { if (input) input.focus(); return Promise.resolve(); }
    return applyCode(code, onSlow);
  }

  function applyCode(code, onSlow) {
    closeSheet();
    return setDiscount(code, onSlow);
  }

  function removeDiscount() {
    return setDiscount('');
  }

  /* ---------- event wiring (delegated — survives re-render) ----------------- */
  function bindRoot(el) {
    if (!el || el.dataset.qcBound === '1') return;
    el.dataset.qcBound = '1';
    if (roots.indexOf(el) === -1) roots.push(el);

    el.addEventListener('click', function (e) {
      root = e.currentTarget;
      var t = e.target;

      // inside the drawer the header X closes the panel instead of navigating
      var headClose = t.closest('.qc-head__close');
      if (headClose && root.classList.contains('qc--drawer')) {
        e.preventDefault();
        closeDrawer();
        return;
      }

      var qtyBtn = t.closest('[data-qc-qty]');
      if (qtyBtn) {
        e.preventDefault();
        var item = qtyBtn.closest('[data-qc-item]');
        var input = item.querySelector('[data-qc-qty-input]');
        var delta = parseInt(qtyBtn.getAttribute('data-qc-qty'), 10);
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
        var max = parseInt(input.getAttribute('max'), 10);
        if (!isNaN(max) && next > max) { toast('Only ' + max + ' available', true); return; }
        input.value = next;
        changeLine(item.getAttribute('data-key'), next, item);
        return;
      }

      var removeBtn = t.closest('[data-qc-remove]');
      if (removeBtn) {
        e.preventDefault();
        var ritem = removeBtn.closest('[data-qc-item]');
        changeLine(ritem.getAttribute('data-key'), 0, ritem).then(function () { toast('Removed from cart'); });
        return;
      }

      var saveBtn = t.closest('[data-qc-save]');
      if (saveBtn) {
        e.preventDefault();
        saveItem(saveBtn.closest('[data-qc-item]'));
        return;
      }

      var moveBtn = t.closest('[data-qc-saved-move]');
      if (moveBtn) {
        e.preventDefault();
        var mrow = moveBtn.closest('[data-qc-saved-row]');
        var mv = mrow.getAttribute('data-variant');
        moveBtn.disabled = true;
        // Save for later now removes the line from the cart, so this
        // normally needs to add it back -- this guard just covers the case
        // where it was somehow already re-added to the cart another way.
        var alreadyInCart = !!findKeyByVariant(mv);
        var moveDone = alreadyInCart
          ? Promise.resolve().then(function () { toast('Already in your cart'); })
          : addVariant(mv, 1, { message: 'Moved to your cart' });
        moveDone
          .then(function () { writeSaved(readSaved().filter(function (x) { return x.variantId !== mv; })); renderSaved(); })
          .catch(function () { moveBtn.disabled = false; });
        return;
      }

      var delSaved = t.closest('[data-qc-saved-remove]');
      if (delSaved) {
        e.preventDefault();
        var drow = delSaved.closest('[data-qc-saved-row]');
        var dv = drow.getAttribute('data-variant');
        writeSaved(readSaved().filter(function (x) { return x.variantId !== dv; }));
        renderSaved();
        return;
      }

      var recAdd = t.closest('[data-qc-rec-add]');
      if (recAdd) {
        e.preventDefault();
        if (recAdd.classList.contains('is-added')) return;
        recAdd.disabled = true;
        var label = recAdd.textContent;
        recAdd.textContent = 'Adding…';
        addVariant(recAdd.getAttribute('data-qc-rec-add'), 1)
          .catch(function () { recAdd.disabled = false; recAdd.textContent = label; });
        return;
      }

      var tab = t.closest('[data-qc-tab]');
      if (tab) { e.preventDefault(); selectTab(tab.getAttribute('data-qc-tab')); return; }

      var totalToggle = t.closest('[data-qc-total-toggle]');
      if (totalToggle) {
        e.preventDefault();
        var alwaysOpen = !root.classList.contains('qc--drawer') &&
                         window.matchMedia('(min-width: 990px)').matches;
        if (alwaysOpen) return;
        state.expanded = !state.expanded;
        restoreBreakdown();
        return;
      }

      var seg = t.closest('[data-qc-offer-tab]');
      if (seg) {
        e.preventDefault();
        switchOfferTab(seg);
        return;
      }

      var couponSubmit = t.closest('[data-qc-coupon-submit]');
      if (couponSubmit && !couponSubmit.disabled) {
        e.preventDefault();
        var box = t.closest('.qc-codebox');
        var couponSubmitLabel = couponSubmit.textContent;
        couponSubmit.disabled = true;
        couponSubmit.setAttribute('aria-busy', 'true');
        couponSubmit.textContent = 'Applying…';
        submitCoupon(box, function () {
          if (document.contains(couponSubmit)) {
            couponSubmit.removeAttribute('aria-busy');
            couponSubmit.textContent = 'Applied \u2713';
          }
        }).then(function () {
          if (document.contains(couponSubmit)) {
            couponSubmit.disabled = false;
            couponSubmit.removeAttribute('aria-busy');
            couponSubmit.textContent = couponSubmitLabel;
          }
        });
        return;
      }

      if (t.closest('[data-qc-goto-look]')) {
        e.preventDefault();
        closeSheet();
        selectTab('look');
        var rail = $('[data-qc-rail]');
        if (rail) rail.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      if (t.closest('[data-qc-open-offers]')) { e.preventDefault(); openSheet(); return; }
      if (t.closest('[data-qc-sheet-close]')) { e.preventDefault(); closeSheet(); return; }

      var applyBtn = t.closest('[data-qc-apply]');
      if (applyBtn && !applyBtn.disabled) {
        e.preventDefault();
        var applyBtnLabel = applyBtn.textContent;
        applyBtn.disabled = true;
        applyBtn.setAttribute('aria-busy', 'true');
        applyBtn.textContent = 'Applying…';
        applyCode(applyBtn.getAttribute('data-qc-apply'), function () {
          if (document.contains(applyBtn)) {
            applyBtn.removeAttribute('aria-busy');
            applyBtn.textContent = 'Applied \u2713';
          }
        }).then(function () {
          // On success the whole section (including this button) is replaced
          // by fresh server markup, so this only matters on failure -- put
          // this exact node back the way it was.
          if (document.contains(applyBtn)) {
            applyBtn.disabled = false;
            applyBtn.removeAttribute('aria-busy');
            applyBtn.textContent = applyBtnLabel;
          }
        });
        return;
      }

      if (t.closest('[data-qc-remove-discount]')) {
        e.preventDefault();
        removeDiscount();
        return;
      }

      var prev = t.closest('[data-qc-rail-prev]');
      var nextBtn = t.closest('[data-qc-rail-next]');
      if (prev || nextBtn) {
        e.preventDefault();
        var rail = $('[data-qc-rail]');
        if (rail) rail.scrollBy({ left: (prev ? -1 : 1) * Math.max(200, rail.clientWidth * 0.8), behavior: 'smooth' });
        return;
      }
    });

    // add-on checkbox
    el.addEventListener('change', function (e) {
      root = e.currentTarget;
      var box = e.target.closest('[data-qc-addon-input]');
      if (box) {
        var label = box.closest('[data-qc-addon]');
        var variant = label.getAttribute('data-variant');
        setBusy(label, true);
        var done = function () { setBusy(label, false); };
        if (box.checked) {
          addVariant(variant, 1, { message: 'Add-on added' }).then(done, function () { box.checked = false; done(); });
        } else {
          var key = findKeyByVariant(variant);
          if (!key) { done(); return; }
          changeLine(key, 0, null).then(function () { toast('Add-on removed'); done(); });
        }
        return;
      }

      var qtyInput = e.target.closest('[data-qc-qty-input]');
      if (qtyInput) {
        var item = qtyInput.closest('[data-qc-item]');
        var val = Math.max(0, parseInt(qtyInput.value, 10) || 0);
        var mx = parseInt(qtyInput.getAttribute('max'), 10);
        if (!isNaN(mx) && val > mx) { val = mx; qtyInput.value = mx; toast('Only ' + mx + ' available', true); }
        changeLine(item.getAttribute('data-key'), val, item);
      }
    });

    // terms gate on checkout
    el.addEventListener('submit', function (e) {
      root = e.currentTarget;
      var btn = $('[data-qc-checkout]');
      if (btn && btn.getAttribute('data-terms-required') === 'true') {
        var terms = $('[data-qc-terms]');
        if (terms && !terms.checked) {
          e.preventDefault();
          toast(window.theme && window.theme.strings && window.theme.strings.cartTermsConfirmation
            ? window.theme.strings.cartTermsConfirmation
            : 'Please accept the terms and conditions to continue', true);
        }
      }
    });

    el.addEventListener('keydown', function (e) {
      root = e.currentTarget;
      if (e.key !== 'Enter') return;
      var input = e.target.closest && e.target.closest('[data-qc-coupon-input]');
      if (!input) return;
      e.preventDefault();
      var box = input.closest('.qc-codebox');
      var goBtn = box && box.querySelector('[data-qc-coupon-submit]');
      var goBtnLabel = goBtn && goBtn.textContent;
      if (goBtn) {
        goBtn.disabled = true;
        goBtn.setAttribute('aria-busy', 'true');
        goBtn.textContent = 'Applying…';
      }
      submitCoupon(box, function () {
        if (goBtn && document.contains(goBtn)) {
          goBtn.removeAttribute('aria-busy');
          goBtn.textContent = 'Applied \u2713';
        }
      }).then(function () {
        if (goBtn && document.contains(goBtn)) {
          goBtn.disabled = false;
          goBtn.removeAttribute('aria-busy');
          goBtn.textContent = goBtnLabel;
        }
      });
    });

    el.addEventListener('scroll', function (e) {
      root = e.currentTarget;
      if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-qc-rail')) syncRailNav();
    }, true);
  }

  /* ---------- drawer ------------------------------------------------------- */
  var drawerLastFocus = null;

  function drawerEl() { return document.getElementById('QueCartPanel'); }

  // The /cart page's own rendering and the drawer's pre-rendered copy both
  // output the identical `.qc--page[data-que-cart]` markup before JS tells
  // them apart (see prepareDrawerRoot) -- so this must explicitly exclude
  // anything sitting inside the drawer to find the page's OWN instance.
  function findPageRoot() {
    var candidates = document.querySelectorAll('.qc--page[data-que-cart]');
    for (var i = 0; i < candidates.length; i++) {
      if (!candidates[i].closest('[data-qc-drawer-body]')) return candidates[i];
    }
    return null;
  }

  function cartPath() {
    var prefix = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (prefix.charAt(prefix.length - 1) !== '/') prefix += '/';
    return prefix + 'cart';
  }

  function drawerSectionId() {
    // Scoped specifically to the drawer's own section instance -- it now
    // coexists with the /cart page's own (differently-id'd) instance, so
    // this must never fall back to "whichever root happens to be first".
    var el = document.querySelector('[data-qc-drawer-body] [data-que-cart]');
    return (el && el.getAttribute('data-section-id')) || 'main-cart';
  }

  function openPanel() {
    var panel = drawerEl();
    if (!panel) return null;
    drawerLastFocus = document.activeElement;
    panel.hidden = false;
    document.body.classList.add('qc-drawer-open');
    document.documentElement.classList.add('qc-drawer-open');
    window.requestAnimationFrame(function () { panel.classList.add('is-open'); });
    var close = panel.querySelector('.qc-drawer__close');
    if (close) close.focus();
    mountDrawerRails();
    return panel;
  }

  function openDrawer(html) {
    loadDrawer(html);
  }

  function closeDrawer() {
    var panel = drawerEl();
    if (!panel || panel.hidden) return;
    panel.classList.remove('is-open');
    document.body.classList.remove('qc-drawer-open');
    document.documentElement.classList.remove('qc-drawer-open');
    window.setTimeout(function () { panel.hidden = true; }, 300);
    if (drawerLastFocus && drawerLastFocus.focus) drawerLastFocus.focus();
  }

  // Applied to any [data-que-cart] markup once it's inside the drawer body --
  // whether it just arrived via fetch (fillDrawer) or was pre-rendered by
  // Liquid on page load (init) -- so it's always styled/marked as the drawer
  // copy, never the standalone-page one.
  function prepareDrawerRoot(el) {
    el.classList.remove('qc--page');
    el.classList.add('qc--drawer');
    el.setAttribute('data-qc-context', 'drawer');
    delete el.dataset.qcBound;
    return el;
  }

  function fillDrawer(html) {
    var body = document.querySelector('[data-qc-drawer-body]');
    if (!body) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector('[data-que-cart]');
    if (!el) return false;

    prepareDrawerRoot(el);

    roots = roots.filter(function (r) { return document.contains(r); });
    body.innerHTML = '';
    body.appendChild(el);

    bindRoot(el);
    var previous = root;
    root = el;
    restoreTab();
    restoreBreakdown();
    renderSaved();
    mountRecommendations();
    mountOffers();
    syncHeaderOffset();
    root = previous && document.contains(previous) ? previous : el;
    updateHeaderBubble();
    return true;
  }

  /*
    Preferred source is the Section Rendering API. Some setups (locale prefixes,
    preview proxies, section id mismatches) don't return it, so fall back to
    scraping the full /cart page, which always contains the same markup.
    cache: 'no-store' + a cache-busting param so a CDN/browser cache can never
    hand back a stale (pre-add) snapshot of the cart.
  */
  function fetchCartMarkup() {
    var sectionUrl = cartPath() + '?section_id=' + encodeURIComponent(drawerSectionId()) + '&_=' + Date.now();
    return fetch(sectionUrl, { headers: { Accept: 'text/html' }, credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) {
        if (!r.ok) throw new Error('section_id ' + r.status);
        return r.text();
      })
      .then(function (html) {
        if (html.indexOf('data-que-cart') === -1) throw new Error('section markup missing');
        return html;
      })
      .catch(function (err) {
        if (window.console) console.warn('[QUE cart] section render unavailable (' + err.message + '), falling back to /cart');
        return fetch(cartPath() + '?_=' + Date.now(), { headers: { Accept: 'text/html' }, credentials: 'same-origin', cache: 'no-store' })
          .then(function (r) {
            if (!r.ok) throw new Error('cart page ' + r.status);
            return r.text();
          });
      });
  }

  /*
    Fills the drawer body with real cart markup FIRST, and only reveals the
    panel once that's done -- so the drawer never becomes visible showing a
    skeleton, a spinner, or nothing. It simply appears already showing the
    actual cart.
  */
  /*
    The drawer body is now pre-rendered by Liquid (see cart-drawer.liquid),
    so it always has a real, current cart in it -- never empty, never a
    skeleton. That means opening can happen the instant html/nothing is
    passed in, with the given/fetched markup swapped in right after (or
    immediately, if it's already on hand).
  */
  function loadDrawer(html) {
    var body = document.querySelector('[data-qc-drawer-body]');
    if (!body) return;

    if (html) { fillDrawer(html); }
    openPanel();
    if (html) return;

    fetchCartMarkup()
      .then(function (markup) { fillDrawer(markup); })
      .catch(function (err) {
        if (window.console) console.error('[QUE cart] drawer refresh failed:', err);
      });
  }

  function addPath() {
    var prefix = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (prefix.charAt(prefix.length - 1) !== '/') prefix += '/';
    return prefix + 'cart/add.js';
  }

  /*
    Adds via the Cart AJAX API. The drawer opens IMMEDIATELY, always -- no
    waiting on the network first, even on the very first add of a session
    when the drawer is still showing its empty state. The actual add request
    runs in parallel; while it's in flight the current drawer body (empty
    state or existing items) is dimmed with a small spinner over it, then the
    accurate, updated cart (new item, updated totals/tiers) silently swaps in
    the moment the response is back -- typically well under a second.
  */
  /*
    True optimistic rendering (showing the item's real photo/price before the
    server confirms it) isn't reliable to build here -- add-to-cart buttons
    live in several different templates (PDP, quick-add, sticky bar, the
    drawer's own upsell rails) with no one consistent place to safely pull an
    accurate image/title/price from. Guessing risks showing the WRONG product
    info for a moment, which is worse than a brief dim+spinner. So the panel
    always opens on click, and the dim/spinner treatment (already defined in
    que-cart.css as .qc-drawer__body.is-refreshing / .qc-drawer__spinner)
    covers the gap until real markup lands.
  */
  function beginDrawerRefresh() {
    var body = document.querySelector('[data-qc-drawer-body]');
    if (!body) return;
    body.classList.add('is-refreshing');
    if (!body.querySelector('[data-qc-drawer-spinner]')) {
      var spinner = document.createElement('div');
      spinner.className = 'qc-drawer__spinner';
      spinner.setAttribute('data-qc-drawer-spinner', '');
      spinner.setAttribute('aria-hidden', 'true');
      body.appendChild(spinner);
    }
  }

  function endDrawerRefresh() {
    var body = document.querySelector('[data-qc-drawer-body]');
    if (!body) return;
    body.classList.remove('is-refreshing');
    var spinner = body.querySelector('[data-qc-drawer-spinner]');
    if (spinner) spinner.remove();
  }

  function onProductSubmit(e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (!drawerEl()) return; // no drawer on the page — let the theme behave normally

    e.preventDefault();
    e.stopPropagation();

    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }

    openPanel();
    beginDrawerRefresh();

    var payload = new FormData(form);
    payload.append('sections', drawerSectionId());

    fetch(addPath(), { method: 'POST', headers: { Accept: 'application/json' }, credentials: 'same-origin', body: payload })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error((data && (data.description || data.message)) || 'Could not add to cart');
          return data;
        });
      })
      .then(function (data) {
        var markup = data && data.sections && data.sections[drawerSectionId()];
        if (markup && markup.indexOf('data-que-cart') !== -1) return markup;
        // Diagnostic: shows exactly what Shopify returned for the section we
        // asked for (or its absence), so we can fix the id/markup mismatch
        // instead of guessing at it.
        if (window.console) {
          console.warn('[QUE cart] add.js did not return usable "' + drawerSectionId() + '" markup; refetching a fresh copy.');
          console.warn('[QUE cart] keys returned:', data && data.sections ? Object.keys(data.sections) : data);
        }
        return fetchCartMarkup();
      })
      .then(function (markup) {
        // fillDrawer replaces the body's innerHTML (wiping the spinner child
        // along with it), but is-refreshing is a class on the body element
        // itself, so that still needs clearing explicitly.
        var ok = fillDrawer(markup);
        endDrawerRefresh();
        if (!ok) throw new Error('Could not load your cart');
      })
      .catch(function (err) {
        endDrawerRefresh();
        closeDrawer();
        toast(err.message, true);
      })
      .then(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; } });
  }

  function bindGlobals() {
    document.addEventListener('submit', onProductSubmit, true);

    document.addEventListener('click', function (e) {
      var opener = e.target.closest && e.target.closest('[data-qc-open-drawer]');
      if (opener && drawerEl()) {
        e.preventDefault();
        // Open instantly with what's already there, then quietly refresh in
        // the background (catches e.g. the cart changing in another tab).
        openPanel();
        fetchCartMarkup()
          .then(function (markup) { fillDrawer(markup); })
          .catch(function (err) {
            if (window.console) console.error('[QUE cart] drawer refresh failed:', err);
          });
        return;
      }
      if (e.target.closest && e.target.closest('[data-qc-drawer-close]')) {
        e.preventDefault();
        closeDrawer();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var sheet = document.querySelector('[data-qc-offers-sheet]');
      if (sheet && !sheet.hidden) { closeSheet(); return; }
      closeDrawer();
    });

    window.addEventListener('resize', function () {
      if (root) syncRailNav();
      syncHeaderOffset();
    });
  }

  /* ---------- boot ---------------------------------------------------------- */
  var globalsBound = false;

  function bindInstance(el, mountRails) {
    bindRoot(el);
    var previous = root;
    root = el;
    restoreTab();
    restoreBreakdown();
    renderSaved();
    if (mountRails) { mountRecommendations(); mountOffers(); }
    root = previous && document.contains(previous) ? previous : el;
    updateHeaderBubble();
  }

  // The rec/offer rails fetch their own product JSON in the background (see
  // mountRecommendations/mountOffers). Firing those for the drawer at page
  // load would mean every visitor, on every page, pays for two extra
  // background requests whether they ever open the cart or not -- so instead
  // they're deferred until the drawer is actually opened, and only run once
  // (state.recKey/offersKey caching makes repeat calls a no-op).
  function mountDrawerRails() {
    var drawerRoot = document.querySelector('[data-qc-drawer-body] > [data-que-cart]');
    if (!drawerRoot) return;
    var previous = root;
    root = drawerRoot;
    mountRecommendations();
    mountOffers();
    root = previous && document.contains(previous) ? previous : drawerRoot;
  }

  function init() {
    // the drawer opener lives on every page, so wire it up regardless
    if (!globalsBound) { globalsBound = true; bindGlobals(); }
    // Lets the tiny inline bootstrap script in cart-drawer.liquid (which
    // covers header-cart clicks while this file is still loading) know it
    // can stand down -- everything from here on goes through bindGlobals'
    // own click handling instead.
    window.__queCartReady = true;

    var page = findPageRoot();
    if (page) {
      if (page.dataset.qcBound === '1') {
        root = page;
      } else {
        bindInstance(page, true);
      }
    }

    // The drawer body is pre-rendered by Liquid now (see cart-drawer.liquid),
    // so it needs the same one-time setup the /cart page's own instance gets
    // -- tabs, saved-for-later -- the moment it lands in the DOM, not just
    // later when que-cart.js re-fills it after a fetch. The rails themselves
    // are deferred (see mountDrawerRails).
    var drawerRoot = document.querySelector('[data-qc-drawer-body] > [data-que-cart]');
    if (drawerRoot && drawerRoot.dataset.qcBound !== '1') {
      prepareDrawerRoot(drawerRoot);
      bindInstance(drawerRoot, false);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Theme editor: section re-rendered by Shopify
  document.addEventListener('shopify:section:load', function (e) {
    var pageEl = findPageRoot();
    var drawerEl2 = document.querySelector('[data-qc-drawer-body] > [data-que-cart]');
    var touched = (pageEl && e.target && e.target.contains && e.target.contains(pageEl)) ||
      (drawerEl2 && e.target && e.target.contains && e.target.contains(drawerEl2));
    if (!touched) return;

    [pageEl, drawerEl2].forEach(function (el) {
      if (!el) return;
      delete el.dataset.qcBound;
      roots = roots.filter(function (r) { return r !== el && document.contains(r); });
    });
    root = null;
    init();
  });
  
})();

/* ---------- rotating promo heading + subheading (any number of pairs; always enters from the right, exits to the left) ---------- */
(function () {
  'use strict';

  function startRotator(el) {
    if (el.dataset.qcRotatorReady === '1') return;
    el.dataset.qcRotatorReady = '1';

    var items = Array.prototype.slice.call(el.querySelectorAll('.qc-promo__slide'));
    if (!items.length) return;

    items.forEach(function (item) {
      item.classList.remove('is-active', 'is-exit', 'is-resetting');
    });
    items[0].classList.add('is-active');

    if (items.length < 2) return; // only one pair: nothing to rotate

    var duration = parseInt(el.dataset.duration, 10);
    if (!duration || duration < 500) duration = 2600;

    var current = 0;

    window.setInterval(function () {
      var prevEl = items[current];
      current = (current + 1) % items.length;
      var nextEl = items[current];

      // previous slide slides out to the left...
      prevEl.classList.remove('is-active');
      prevEl.classList.add('is-exit');

      // ...while the next slide slides in from the right, always.
      nextEl.classList.add('is-active');

      // once the exit transition has finished, snap the exited slide back to
      // its resting position on the right (transition disabled for that one
      // frame) so it's ready to enter from the right again on its next turn.
      window.setTimeout(function () {
        prevEl.classList.add('is-resetting');
        prevEl.classList.remove('is-exit');
        void prevEl.offsetWidth; // force reflow so the reset is applied instantly
        window.requestAnimationFrame(function () {
          prevEl.classList.remove('is-resetting');
        });
      }, 520);
    }, duration);
  }

  function scanRotators() {
    var els = document.querySelectorAll('[data-qc-rotator]');
    for (var i = 0; i < els.length; i++) startRotator(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanRotators);
  } else {
    scanRotators();
  }

  // The cart drawer/page body is re-rendered on add-to-cart, quantity changes,
  // and theme-editor updates, so new rotators can appear at any time.
  new MutationObserver(scanRotators).observe(document.documentElement, { childList: true, subtree: true });
})();